import { RefObject } from 'react'

import { useScrollspy } from './useScrollspy'

export { useScrollspy }

type Props = {
  children: ({
    currentElementIndexInViewport,
    elementsStatusInViewport,
  }: {
    currentElementIndexInViewport: number
    elementsStatusInViewport: boolean[]
  }) => JSX.Element
  offset?: number
  rootSelector?: string
  sectionRefs: RefObject<Element>[]
}

const Scrollspy = ({ children, offset, rootSelector, sectionRefs }: Props) => {
  const { currentElementIndexInViewport, elementsStatusInViewport } = useScrollspy({
    offset,
    rootSelector,
    sectionRefs,
  })

  return children({
    currentElementIndexInViewport,
    elementsStatusInViewport,
  })
}

export default Scrollspy
